import '@/assets/scss/adaptWrapper.scss'
import { deviceType } from '@/utils/common'
import PcRootLayout from './pc/layout/rootLayout.vue'
import MobileRootLayout from './mobile/layout/rootLayout.vue'
import referralsRoute from './referralsRoute'
import functionsRoute from './functionsRoute'
import applicationsRoute from './applicationsRoute'
import consentRoute, { PersonalHomeConsentRoute } from './consentRoute'
import homeRoute from './homeRoute'
import profileRoute from './profileRoute'
import reportRoute from './reportRoute'
import offerLetterRoute from './offerLetterRoute'
import referralProgram from './referralProgram'

const basePath = '/recruiting/personal'

const routes = [
  applicationsRoute,
  homeRoute,
  profileRoute,
  reportRoute,
  referralsRoute,
  functionsRoute,
  offerLetterRoute,
  referralProgram,
  PersonalHomeConsentRoute
]

export default [
  {
    path: `${basePath}`,
    redirect: `${basePath}/home`,
    component: deviceType.isPc ? PcRootLayout : MobileRootLayout,
    meta: {
      isInclude: false,
      menuI18nKey: 'personal.resume.tabTitle.index'
    },
    children: routes
  },
  consentRoute
]
